import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "successWrapper" }
const _hoisted_2 = { class: "flex items-center justify-center h-screen" }
const _hoisted_3 = {
  key: 0,
  class: "successBox"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "successIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-check" })
], -1)

import {computed, onMounted} from "vue";
import { useGlobalStore } from '@/stores/GlobalStore'
import sleep from "@/utilities/helpers/Sleeper";
import {OverlayType} from "@/utilities/enums/Enums";
import Progressbar from "@/components/Progressbar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Success',
  setup(__props) {

const globalStore = useGlobalStore();

const progressPercentage = computed(() => {
  if (globalStore.success.progressPercentage === "100%") {
    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    globalStore.success.show = false;
    return globalStore.success.progressPercentage
  }
  return globalStore.success.progressPercentage
});

onMounted(async () => {
	if (globalStore.success.type === OverlayType.temporary){
    await sleep(2000);
    globalStore.success.show = false;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(globalStore).success.type === _unref(OverlayType).temporary)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(_unref(globalStore).success.text) + " ", 1),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_unref(globalStore).success.type === _unref(OverlayType).progress)
        ? (_openBlock(), _createBlock(Progressbar, {
            key: 1,
            class: "downloadProgress",
            barColor: '#D01D74',
            percentage: progressPercentage.value
          }, null, 8, ["percentage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})